import { lazy } from 'react';

export const PlayerSelfExclusionForm = lazy(
  () => import('./PlayerSelfExclusionForm'),
);
